import setupAxios from '../../lib/redux/setupAxios'
import qs from 'qs'

export const getAllAppsList = async (queryParams) => {
    return setupAxios
        .get('/app_list', {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const getAppListByID = async (id) => {
    return setupAxios
        .get(`/app_list/get_app_data/${id}`)
        .then((res) => res?.data?.data)
}

export const getAppUsageActivity = async (queryParams) => {
    const queryString = qs.stringify(queryParams, {
        encode: true, // ensures proper URL encoding
        skipNulls: true, // skip null or undefined values
        format: 'RFC3986', 
    })

    return setupAxios
        .get(`/events/get_app_events?${queryString}`)
        .then((res) => res?.data?.data)
}

export const getUserSpecificAppEvents = async (queryParams) => {
    const queryString = qs.stringify(queryParams, {
        encode: true,
        skipNulls: true,
        format: 'RFC3986',
    })

    return setupAxios
        .get(`/events/get_user_specific_app_events?${queryString}`)
        .then((res) => res?.data?.data)
}

export const getSameCategoryApps = async ({ id, queryParams }) => {
    return setupAxios
        .get(`/app_list/get_same_category_apps/${id}`, {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const updateAppByID = async ({ id, formData }) => {
    return setupAxios.put(`/app_list/${id}`, formData).then((res) => res?.data)
}

export const getUniqueApp = async (id) => {
    return setupAxios
        .get(`/app_list/get_unique_new_app/${id}`)
        .then((res) => res?.data?.data)
}

export const categorizeNewApp = async ({ id, formData }) => {
    return setupAxios
        .post(`/app_list/categorize_new_app/${id}`, formData)
        .then((res) => res?.data)
}
export const getUserAssignedAppList = async (queryParams) => {
    return setupAxios
        .get(`/app_list_user`, {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const getAllFilteredUserAssignedAppList = async (payload) => {
    return setupAxios
        .post(`/app_list_user/filter`, payload)
        .then((res) => res?.data?.data)
}

export const assignAppToSpecificUser = async (formData) => {
    return setupAxios.post(`/app_list_user`, formData).then((res) => res?.data)
}

export const getAssignedAppToSpecificUser = async (id) => {
    return setupAxios.get(`/app_list_user/${id}`).then((res) => res?.data?.data)
}

export const createAssignedAppToSpecificUser = async (formData) => {
    return setupAxios.post(`/app_list_user`, formData).then((res) => res?.data)
}
export const updateAssignedAppToSpecificUser = async ({ id, formData }) =>
    setupAxios.put(`/app_list_user/${id}`, formData).then((res) => res?.data)

export const getAllRefStatus = async (queryParams) => {
    return setupAxios
        .get(`/ref_status`, {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}
export const getScoreAdjustmentFlags = async (queryParams) => {
    return setupAxios
        .get(`/score_adjustment_flags`, { params: queryParams })
        .then((res) => res?.data?.data)
}
export const getReasonAdjustment = async (queryParams) => {
    return setupAxios
        .get(`/score_adjustment_reason`, { params: queryParams })
        .then((res) => res?.data?.data)
}

export const deleteAppListByID = async (id) => {
    return setupAxios.delete(`/app_list/${id}`).then((res) => res?.data)
}

export const unGroupAppListByID = async ({ id, payload }) => {
    return setupAxios
        .post(`/app_list/remove_app/${id}`, payload)
        .then((res) => res?.data)
}

export const getAllFilteredAppList = async (payload) => {
    return setupAxios
        .post(`/app_list/filter`, payload)
        .then((res) => res?.data?.data)
}

export const skipNewApp = async ({ id }) => {
    return setupAxios
        .post(`/app_list/skip_new_app/${id}`)
        .then((res) => res?.data)
}

export const fetchAllAppCategoryTypes = async (queryParams) => {
    return setupAxios
        .get(`app_category_types`, {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const deleteAssignedAppToSpecificUser = async (id) => {
    return setupAxios.delete(`/app_list_user/${id}`).then((res) => res?.data)
}

// Get installer sources of the app
export const installerSourcesOfApp = async (id) => {
    return setupAxios
        .get(`/app_list/get_app_installer_source/${id}`)
        .then((res) => res.data)
}
export const newAppListCount = async () => {
    return setupAxios.get(`/app_list/get_new_app_count`).then((res) => res.data?.data || res.data)
}

export const getTrackViewURL = async (id, payload) => {
    const res = await setupAxios.post(`/app_list/get_trackview_url/${id}`, payload);
    return res.data;
  };

export const uploadAppImage = async ({ app_id, imageFile }) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    return setupAxios
        .post(`/app_list/upload_app_image/${app_id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => res?.data);
};